import axiosWithAuth from '../utils/axiosWithAuth';

/**
 * Get all tariffs
 * @returns {Promise<Object>} - The tariffs data
 */
export const getTariffs = async () => {
  try {
    const api = axiosWithAuth();
    const response = await api.get('/repair-tariffs');
    return response.data;
  } catch (error) {
    console.error('Error fetching tariffs:', error);
    throw error;
  }
};

/**
 * Get tariff details by ID
 * @param {string} tariffId - The ID of the tariff to fetch
 * @returns {Promise<Object>} - The tariff data
 */
export const getTariffById = async (tariffId) => {
  try {
    const api = axiosWithAuth();
    const response = await api.get(`/repair-tariffs/${tariffId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching tariff details:', error);
    throw error;
  }
};

const tariffsService = {
  getTariffs,
  getTariffById
};

export default tariffsService; 